export default __webpack_public_path__ + "static/media/thumbnail1.e7845485.jpg";